import { render, staticRenderFns } from "./QuotesWithHeadshots.vue?vue&type=template&id=407e7d26&scoped=true"
import script from "./QuotesWithHeadshots.vue?vue&type=script&lang=js"
export * from "./QuotesWithHeadshots.vue?vue&type=script&lang=js"
import style0 from "./QuotesWithHeadshots.vue?vue&type=style&index=0&id=407e7d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e7d26",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Carousel: require('/home/runner/work/marketing/marketing/components/Carousel.vue').default})
